import React from 'react';
import { TEST_IDS } from '../../primitives/testIds';
import { HeaderPartnerDetails } from '../HeaderPartnerDetails';
import { InstallCount, useInstallMessage } from '../InstallCount';
import { AppDetailsContainer, AppName, CertificationContainer, CompatibilitiesContainer, HeaderContainer, HeaderInjectionContainer, IconContainer, InstallCountContainer, RatingsContainer, TrustSignalsContainer, TrustSignalsRow } from './AppHeader.styles';
import * as utils from './AppHeader.utils';
import HeaderAppIcon, { getAppIcon } from './components/HeaderAppIcon';
import HeaderCertificationBadge from './components/HeaderCertificationBadge';
import HeaderLozenges from './components/HeaderLozenges';
import HeaderRatings from './components/HeaderRatings';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function AppHeader(_ref) {
  var _appHeaderDetails$com;
  let {
    appHeaderDetails,
    appIconLink,
    appIconSize = 'large',
    appRatingLink,
    bottomSeparator = true,
    compatibilitySummary = null,
    headerInjection,
    isAppCloudFortified = false,
    lozenges = [],
    openMarketplaceLinksInNewTab = true,
    showInstallationCount = false,
    bugBountyParticipant = null,
    isRunsOnAtlassianApp = false
  } = _ref;
  const showNewAppMessage = utils.showNewAppMessage(appHeaderDetails);
  const {
    tooltipMessage: installTooltipMessage,
    installCountMessage,
    showDownloadIcon,
    isLoading: isInstallMessageLoading
  } = useInstallMessage({
    distribution: appHeaderDetails.distribution,
    showNewAppMessage,
    compatibleProducts: (_appHeaderDetails$com = appHeaderDetails.compatibleProducts) !== null && _appHeaderDetails$com !== void 0 ? _appHeaderDetails$com : [],
    enableAppificationChanges: false,
    showAetherAppListingPage: false
  });
  return /*#__PURE__*/_jsxs(HeaderContainer, {
    "data-testid": TEST_IDS.APP_HEADER,
    bottomSeparator: bottomSeparator,
    children: [/*#__PURE__*/_jsx(IconContainer, {
      "data-testid": TEST_IDS.APP_HEADER_ICON,
      children: /*#__PURE__*/_jsx(HeaderAppIcon, {
        size: appIconSize,
        origin: appHeaderDetails.origin,
        icon: appHeaderDetails.icon,
        appKey: appHeaderDetails.key,
        appIconLink: appIconLink
      })
    }), /*#__PURE__*/_jsxs(AppDetailsContainer, {
      children: [/*#__PURE__*/_jsx(AppName, {
        "data-testid": TEST_IDS.APP_HEADER_APP_NAME,
        children: appHeaderDetails.name
      }), /*#__PURE__*/_jsx(HeaderPartnerDetails, {
        name: appHeaderDetails.partner.name,
        link: appHeaderDetails.partner.link,
        partnerTierType: appHeaderDetails.partner.partnerTierType
      }), compatibilitySummary && /*#__PURE__*/_jsx(CompatibilitiesContainer, {
        "data-testid": TEST_IDS.APP_HEADER_COMPATIBILITIES,
        children: compatibilitySummary
      })]
    }), /*#__PURE__*/_jsxs(TrustSignalsContainer, {
      children: [/*#__PURE__*/_jsxs(TrustSignalsRow, {
        children: [!showNewAppMessage && /*#__PURE__*/_jsx(RatingsContainer, {
          "data-testid": TEST_IDS.APP_HEADER_RATINGS,
          children: /*#__PURE__*/_jsx(HeaderRatings, {
            appKey: appHeaderDetails.key,
            appRatingLink: appRatingLink,
            openMarketplaceLinksInNewTab: openMarketplaceLinksInNewTab,
            ratings: appHeaderDetails.ratings
          })
        }), showInstallationCount && /*#__PURE__*/_jsx(InstallCountContainer, {
          "data-testid": TEST_IDS.APP_HEADER_INSTALL_COUNT,
          children: /*#__PURE__*/_jsx(InstallCount, {
            tooltipMessage: installTooltipMessage,
            installCountMessage: installCountMessage,
            showDownloadIcon: showDownloadIcon,
            isLoading: isInstallMessageLoading
          })
        }), /*#__PURE__*/_jsx(CertificationContainer, {
          "data-testid": TEST_IDS.APP_HEADER_CERTIFICATION,
          children: /*#__PURE__*/_jsx(HeaderCertificationBadge, {
            isAppCloudFortified: isAppCloudFortified,
            bugBountyParticipant: bugBountyParticipant,
            isRunsOnAtlassianApp: isRunsOnAtlassianApp
          })
        })]
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(HeaderLozenges, {
          lozenges: lozenges
        })
      })]
    }), !!headerInjection && /*#__PURE__*/_jsx(HeaderInjectionContainer, {
      children: headerInjection
    })]
  });
}
AppHeader.getAppIcon = getAppIcon;
export default AppHeader;